import ErrorBoundary from 'lib/components/misc/ErrorBoundary';
import Layout from 'lib/components/misc/Layout';
import SignupForm from 'lib/components/ui/SignupForm';
import { useTranslation } from 'lib/translation';

const Signup = () => {
  const { translate } = useTranslation();

  return (
    <ErrorBoundary>
      <Layout title={translate('page.signup')}>
        <SignupForm />
      </Layout>
    </ErrorBoundary>
  );
};

export default Signup;
